






























import { Component, Vue } from 'vue-property-decorator';
import { Toast } from 'vant';
import { employeeApis, Employee, InvalidParam } from '@/api';
import { encryptPassword } from '@/common';
import { isInDingtalk, DingtalkCorpId } from '@/common/dingtalk';
import * as dd from 'dingtalk-jsapi';
import { Dialog } from 'vant';

@Component
export default class extends Vue {
  private newPassword = '';
  private newPasswordValid = '';
  private errors: Record<string, string> = {};
  private timeStop: any = null;
  private timeStopStep = 60;
  private loading = false;

  get employee(): Employee {
    return this.$store.getters['employee/get'];
  }

  created() {
    if (!isInDingtalk() && !this.$isDebug) {
      Dialog.alert({
        message: '此功能只在钉钉环境生效,点击确认返回'
      }).then(() => {
        this.$router.go(-1);
      });
    }
  }

  submitPassword() {
    if (!isInDingtalk()) {
      Toast.fail('此接口只在钉钉环境生效');
      return;
    }

    if (this.newPassword.length == 0) {
      Toast.fail('密码不可以为空');
      return;
    }
    if (this.newPassword != this.newPasswordValid) {
      Toast.fail('两次输入的密码不一样');
      return;
    }

    dd.ready(() => {
      dd.runtime.permission
        .requestAuthCode({
          corpId: DingtalkCorpId
        })
        .then(async info => {
          encryptPassword(this.newPassword).then(r => {
            this.loading = true;
            employeeApis
              .resetPasswordByDingtalk({
                new_password: r as string,
                code: info.code
              })
              .then(() => {
                Toast.success(`密码已重置成功`);
                setTimeout(() => {
                  this.$router.push({ name: 'MyInfo' });
                }, 1000);
              })
              .catch(e => {
                if (e instanceof InvalidParam) {
                  this.errors = e.params as any;
                  Toast({
                    message: '密码重置失败',
                    position: 'top'
                  });
                } else {
                  Toast.fail(`密码重置失败:${e.message}`);
                }
              })
              .finally(() => {
                this.loading = false;
              });
          });
        });
    });

    return true;
  }
}
